import { render, staticRenderFns } from "./ModalMessageBox.vue?vue&type=template&id=036e638d&"
import script from "./ModalMessageBox.vue?vue&type=script&lang=js&"
export * from "./ModalMessageBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports